import React from "react";
import OrdersDashboard from "./OrdersDashboard";

function DeliveryDashboard() {
  return <OrdersDashboard userRole="Delivery" />;
}

export default DeliveryDashboard;
